import {CollapsiblePanel} from '@esgi/main/features/admins/data';
import {styled} from '@esgi/ui/theme';

export const ExpandedPanel = styled(CollapsiblePanel.Panel, {
	backgroundColor: '$background',
	overflow: 'hidden',
	height: '100%',
});
